export const styles = theme => ({
    root: {
        width: '100%',
        gridColumnStart: 2,
        gridColumnEnd: 4,
    },
    contentWrapper: {
        display: 'grid',
        gridTemplateColumns: '1fr 4fr 4fr 1fr'
    },
    buttonS: {
        marginTop: theme.spacing.unit,
        marginBottom:theme.spacing.unit,
        fontFamily: 'PT Sans Narrow',
        fontSize: '15px',
        borderRadius: 0,
        boxShadow: 'none',
        color: '#fff',
        backgroundColor: '#76b5b8'
    },
    button: {
        marginTop: theme.spacing.unit,
        marginBottom:theme.spacing.unit,
        fontFamily: 'PT Sans Narrow',
        fontSize: '15px',
        borderRadius: 0,
        boxShadow: 'none',
        float: 'right',
        color: '#fff',
        backgroundColor: '#76b5b8'
    },

    buttonLeft:{
        marginTop: theme.spacing.unit,
        marginBottom:theme.spacing.unit*3,
        fontFamily: 'PT Sans Narrow',
        fontSize: '15px',
        borderRadius: 0,
        boxShadow: 'none',
        float: 'left',
        color: '#fff',
        backgroundColor: '#76b5b8',
    },
    headerStatic:{
        margin: '60px 0',
        fontSize: 26,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold'
    },
    textStatic:{
        margin: '60px 0',
        maxWidth: '65%',
        color: '#5b5b5b'
    },
    container: {
        alignItems: 'center',
        flexWrap: 'wrap',
        marginTop: '60px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    h5: {
        color:'#76b5b8',
        fontSize: 22,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 100
    },
    rootFlex: {
        display: 'flex',
        color: '#76b5b8',
    },
    wrapperButton:{
        width: '100%',
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    newColor: {
        color:'#76b5b8',
        borderBottom: '2px solid #76b5b8',
        '&::after':{
            borderBottom: '2px solid #76b5b8'
        },
        "&:hover":{
            border: 'none'
        },
        '&::before': {
            borderColor: ''
        }
    },
    label: {
        color: '#76b5b8 !important',
    },
    input: {
        '&::after':{
            borderBottom: '1px solid #76b5b8'
        },
        "&:hover":{
            borderBottom: '1px solid rgba(189, 235, 255, 0.8)'
        },
        '&::before': {
            borderBottom: '1px solid rgba(189, 235, 255, 0.6) !important'
        }
    },
    tabRoot: {
        textTransform: 'none',
        transition: 'none'
    },
    tabLabel: {
        color:'#76b5b8',
        fontSize: 22,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 100
    },
    appBar: {
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    indicator:{
        backgroundColor: '#76b5b8',
    },
    notificationPageLabel: {
        fontSize: '13px',
        display: 'block',
        margin: '10px 0 -5px 0',
    }
});


// WEBPACK FOOTER //
// ./assets/src/js/helpers/classes.jsx